import * as React from "react";
import { PrimaryButton, Color, Spinner } from "@root/shared";
import { LoginShell } from "../../login/login-shell";
import { Grid, Col, Row, GridSpacing } from "@root/shared/grid";
import { ActionText, ErrorBlock, ProductLogo } from "@root/shared";
import { observer } from "mobx-react";

import { AppInvitationStore } from "../../stores/app-invitation-store";

const styles = require("./app-invitation.scss");

export interface IAppInvitationProps {
  ownerName?: string;
  appName?: string;
  appDisplayName?: string;
  inviterName?: string;
  token?: string;
  hasPendingInvitation?: boolean;
}

@observer
export class AppInvitation extends React.Component<IAppInvitationProps, {}> {
  private appInvitationStore?: AppInvitationStore;

  public UNSAFE_componentWillMount() {
    this.initProps = (window as any).initProps;
    this.appInvitationStore = new AppInvitationStore(this.initProps?.token, this.initProps?.ownerName, this.initProps?.appName);
  }

  private initProps?: IAppInvitationProps;

  public showErrorMessage(message: string) {
    if (message == null) {
      return null;
    }

    return <ErrorBlock>{message}</ErrorBlock>;
  }

  public render() {
    if (this.initProps?.hasPendingInvitation) {
      return this.renderChoice(this.initProps);
    } else {
      return this.renderNoInvite();
    }
  }

  public renderChoice(props: IAppInvitationProps) {
    return (
      <LoginShell>
        <Grid rowSpacing={GridSpacing.XLarge}>
          <Row>
            <Col>
              <ProductLogo className={styles["logo"]} />
            </Col>
          </Row>
          <Row>
            <Col width={12} className={styles["invitation-text"]}>
              <strong>{props.inviterName}</strong> invited you to join <strong>{props.appDisplayName}</strong>.<br />
              Would you like to join?
            </Col>
          </Row>
          {this.appInvitationStore?.isActionPending ? (
            <Row>
              <Col width={12}>
                <Spinner />
              </Col>
            </Row>
          ) : (
            <Row>
              <Col width={12} className={styles["actions"]}>
                <PrimaryButton onClick={() => this.appInvitationStore?.accept()} color={Color.Blue}>
                  Join app
                </PrimaryButton>
                <ActionText className={styles["decline"]} onClick={() => this.appInvitationStore?.reject()}>
                  Decline
                </ActionText>
              </Col>
            </Row>
          )}
          {this.appInvitationStore?.errorMessage ? (
            <Row>
              <Col width={12}>{this.showErrorMessage(this.appInvitationStore.errorMessage)}</Col>
            </Row>
          ) : null}
        </Grid>
      </LoginShell>
    );
  }

  public renderNoInvite() {
    return (
      <LoginShell>
        <Grid rowSpacing={GridSpacing.XLarge}>
          <Row>
            <Col>
              <ProductLogo className={styles["logo"]} />
            </Col>
          </Row>
          <Row>
            <Col width={12} className={styles["invitation-text"]}>
              The app invitation is expired or invalid.
            </Col>
          </Row>
          <Row>
            <Col width={12}>
              <PrimaryButton onClick={() => window.location.assign("/")} color={Color.Blue}>
                Home
              </PrimaryButton>
            </Col>
          </Row>
        </Grid>
      </LoginShell>
    );
  }
}
